/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSelfCareWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSelfCareWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Prioritize Self-Care!",
    "Self-Care Workshop Awaits!",
    "Nurture Yourself Together!",
  ],
  title: "Self-Care Workshop",
  description: "Organize a relaxing self-care workshop.",
  longDescription:
    "Gather your friends for a rejuvenating self-care workshop! Choose a date, decide on activities, and plan refreshments!",
  emoji: "🌿",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Self-Care Workshop",
          emoji: "🌿",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the self-care workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on self-care activities?",
            description:
              "What activities should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we plan for the workshop?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "☕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Relax and Refresh!",
    outroDescription:
      "Your self-care workshop plans are set! Enjoy the relaxation!",
  },
};
